import { getComponentOverrides } from './getComponentOverrides';
import merge from 'lodash/merge';
export var applyComponentStyleOverride = function applyComponentStyleOverride(componentName, styleOverride) {
  return function (componentTheme, props, state) {
    var originalOverrides = typeof styleOverride === 'function' ? styleOverride(componentTheme, props, state) : styleOverride;
    var externalOverrides = getComponentOverrides(componentName);
    return merge(originalOverrides, externalOverrides);
  };
};